<template>
  <div class="projects">
    <div class="projects__inner">
      <div class="projects__container" :class="customClasses" :style="customStyle">
        <TheProjectsCategories ref="categories" :categories="categories" @select="handleSelect" />
        <TheProjectsList ref="projects" :category="currentCategory" @back="handleBack" />
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { wait } from '@modules/time'
import TheProjectsCategories from './TheProjectsCategories'
import TheProjectsList from './TheProjectsList'

export default {
  name: 'TheProjects',
  props: {
    categories: {
      type: Array,
      required: true
    }
  },
  components: {
    TheProjectsList,
    TheProjectsCategories
  },
  data () {
    return {
      currentCategory: {
        name: '',
        title: '',
        text: '',
        items: []
      },
      showProjects: false,
      height: null
    }
  },
  computed: {
    customClasses () {
      return [
        { 'is-active': this.showProjects }
      ]
    },
    customStyle () {
      return this.height !== null ? `height: ${this.height}px;` : ''
    }
  },
  watch: {
    projects () {
      this.updateHeight()
    },
    showProjects () {
      this.$scrollTo('body')
      this.updateHeight()
    }
  },
  methods: {
    handleSelect (category) {
      this.showProjects = true
      this.updateCurrentCategory(category)
    },
    handleBack () {
      this.showProjects = false
    },
    updateHeight () {
      this.height = null
      wait(300, () => {
        this.height = this.showProjects
          ? this.$refs.projects.$el.offsetHeight
          : this.$refs.categories.$el.offsetHeight
      })
    },
    updateCurrentCategory (category) {
      this.currentCategory = cloneDeep(category)
    }
  }
}
</script>

<style lang="scss">
.projects{
  @include media("small") {
    padding: layout("spacing") layout("spacing")/2;
  }
  @include media("medium") {
    padding: layout("spacing")*1.5;
  }
  @include media("small-medium"){
    align-items: flex-start;
  }
  @include media("large"){
    padding: 7rem 6rem;
    align-items: flex-end;
  }

  display: flex;
  justify-content: flex-start;

  flex-direction: column;

  // Inner

  &__inner{
    @include media("large"){
      max-width: 60rem;
    }
    width: 100%;
    padding-bottom: layout("spacing");
  }

  // Container

  &__container{
    @include add-transition(400ms);
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;

    &.is-active{
      .projects-categories{
        opacity: 0;
        visibility: hidden;
        transform: translateX(-100%);
      }
      .projects-list{
        opacity: 1;
        visibility: visible;
        transform: translateX(-100%);
      }
    }

    .projects-categories,
    .projects-list{
      @include add-transition(400ms);
    }

    .projects-list{
      width: 100%;
      opacity: 1;
      visibility: visible;
    }

    > div{
      flex: 1 0 auto;
      width: 100%;
    }
  }
}

@keyframes hideCategories{
0% {
  opacity: 1;
  transform: translateX(0) translateZ(0);
}

100% {
  opacity: 0;
  transform: translateX(-100%) translateZ(0);
}
}

@keyframes showCategories
{
0% {
  opacity: 0;
  transform: translateX(-100%) translateZ(0);
}

100% {
  opacity: 1;
  transform: translateX(0%) translateZ(0);
}
}

@keyframes showProjects
{
0% {
  opacity: 0;
  transform: translateX(0) translateZ(0);
}

100% {
  opacity: 1;
  transform: translateX(-100%) translateZ(0);
}
}

@keyframes hideProjects
{
0% {
  opacity: 1;
  transform: translateX(-100%) translateZ(0);
}

100% {
  opacity: 0;
  transform: translateX(0) translateZ(0);
}
}

.hideCategories{
  animation-name: 'hideCategories';
}

.showCategories{
  animation-name: 'showCategories';
}

.showProjects{
  animation-name: 'showProjects';
}

.hideProjects{
  animation-name: 'hideProjects';
}
</style>
